import React, { ReactElement } from 'react'
// constants
import { Modals } from 'constants/index'
// context
import { ObjectsAPIContext } from 'containers/ObjectsAndProperties/Edit/layers/API'
// hooks
import { useShowModal } from 'hooks/index'
// themes
import { EllipsizedText } from 'themes/views/generic'
// views
import { ButtonsWrapper, Button, DotsIcon, EditIcon, IconWrapper, TrashIcon, Wrapper, PropertyTitle } from './view'
// utils
import { getIconForProperty } from 'utils/fields'

// types
interface IIncomingProps {
  icon?: ReactElement
  innerRef?: (HTMLElement) => void
  isDefaultProperty?: boolean
  isPlanType?: boolean
  property: any
}

const Property: React.FC<IIncomingProps> = ({ innerRef, isDefaultProperty, isPlanType, property, ...rest }) => {
  // state
  const [isHovered, setHovered] = React.useState<boolean>(false)

  // context
  const { deleteField } = React.useContext(ObjectsAPIContext)

  // redux
  const { showModal } = useShowModal({ modalType: Modals.PROPERTY_DETAILS_MODAL })

  // methods
  const showDetailsDrawer = () => {
    if (!isDefaultProperty) {
      showModal({ property, isPlanType })
    }
  }

  const onTrashIconClick = (event) => {
    event.stopPropagation()

    deleteField(property.id, isPlanType)
  }

  const onMouseEnter = () => setHovered(true)

  const onMouseLeave = () => setHovered(false)

  // constants
  const shouldShowButtons = !isDefaultProperty && isHovered && !property.standard

  return (
    <Wrapper
      isHovered={isHovered}
      onClick={showDetailsDrawer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={innerRef}
      data-testid='property-row'
      data-entity-id={property.id}
      {...rest}>
      {isHovered && (
        <IconWrapper>
          <DotsIcon htmlColor='white' />
        </IconWrapper>
      )}
      <PropertyTitle isActive={property.active}>
        {getIconForProperty(property.fieldType)}
        <EllipsizedText>{property.label}</EllipsizedText>
      </PropertyTitle>
      {shouldShowButtons && (
        <ButtonsWrapper>
          <Button data-entity-id={property.id} onClick={showDetailsDrawer}>
            <EditIcon />
          </Button>
          <Button data-entity-id={property.id} onClick={onTrashIconClick}>
            <TrashIcon />
          </Button>
        </ButtonsWrapper>
      )}
    </Wrapper>
  )
}

export default Property
